import React, { useState, useEffect } from 'react';
import { UncontrolledPopover, PopoverHeader, PopoverBody } from 'reactstrap';
import Select from "react-select";
import Swal from "sweetalert2/dist/sweetalert2.js";

const EXCLUDED_TYPES = ['format_id', 'answer_subform', 'answer_localization', 'localization'];

const FormCreate = (props) => {
    const [selectedOptionQuestionSource, setSelectedOptionQuestionSource] = useState({ label: (props.modeEdit ? props.format_duplication_item.question_source.label : ""), value: (props.modeEdit ? props.format_duplication_item.question_source.value : ""), question_source_id: (props.modeEdit ? props.format_duplication_item.question_source.value : "") });
    const [selectedOptionQuestionTarget, setSelectedOptionQuestionTarget] = useState({ label: (props.modeEdit ? props.format_duplication_item.question_target.label : ""), value: (props.modeEdit ? props.format_duplication_item.question_target.value : ""), question_target_id: (props.modeEdit ? props.format_duplication_item.question_target.value : "") });

    const [questionsSource, setQuestionsSource] = useState([]);
    const [questionsTargetAll, setQuestionsTargetAll] = useState([]);
    const [selectedSourceType, setSelectedSourceType] = useState(null);

    const token = document.querySelector("[name='csrf-token']").content;

    const messageSuccess = (response) => {
        Swal.fire({
            position: "center",
            type: `${response.type}`,
            title: `${response.success}`,
            showConfirmButton: false,
            timer: 1500,
        });
    };

    const clearValues = () => {
        setSelectedOptionQuestionSource({ label: "", value: "", question_source_id: "" })
        setSelectedOptionQuestionTarget({ label: "", value: "", question_target_id: "" })
        setSelectedSourceType(null);
    }

    const handleChangeAutocompleteQuestionSource = (selectedOptionQuestion) => {
        setSelectedOptionQuestionSource({ label: selectedOptionQuestion.label, value: selectedOptionQuestion.value, question_source_id: selectedOptionQuestion.value, question_type: selectedOptionQuestion.question_type });
        setSelectedSourceType(selectedOptionQuestion.question_type);
        // Reset target when source changes
        setSelectedOptionQuestionTarget({ label: "", value: "", question_target_id: "" });
        // Update both fields in one call to avoid race condition
        props.handleChangeFormatDuplicateItem({ question_source_id: selectedOptionQuestion.value, question_target_id: "" });
    }

    const handleChangeAutocompleteQuestionTarget = (selectedOptionQuestion) => {
        setSelectedOptionQuestionTarget(selectedOptionQuestion);
        props.handleChangeFormatDuplicateItem("question_target_id", selectedOptionQuestion.value);
    }

    useEffect(() => {
        loadQuestionSource();
        loadQuestionTarget();
    }, []);

    const loadQuestionSource = () => {
        fetch(`/formatos/data_questions/${props.format_duplication.format_subform_source.id}`, {
            method: 'GET',
            headers: { "X-CSRF-Token": token, "Content-Type": "application/json" }
        })
        .then(response => response.json())
        .then(data => {
            const array = data.steps_questions
                .filter(item => !EXCLUDED_TYPES.includes(item.question_type))
                .map(item => ({ label: item.question, value: item.id, question_type: item.question_type }));
            setQuestionsSource(array);
        });
    }

    const loadQuestionTarget = () => {
        fetch(`/formatos/data_questions/${props.format_duplication.format_subform_target.id}`, {
            method: 'GET',
            headers: { "X-CSRF-Token": token, "Content-Type": "application/json" }
        })
        .then(response => response.json())
        .then(data => {
            const array = data.steps_questions
                .filter(item => !EXCLUDED_TYPES.includes(item.question_type))
                .map(item => ({ label: item.question, value: item.id, question_type: item.question_type }));
            setQuestionsTargetAll(array);
        });
    }

    // Filter target questions by selected source type
    const questionsTargetFiltered = selectedSourceType
        ? questionsTargetAll.filter(q => q.question_type === selectedSourceType)
        : questionsTargetAll;

    const handleClick = () => {
        if(props.modeEdit){
            fetch(`/formatos/format_duplication_items/${props.format_duplication_item.id}`, {
                method: 'PATCH', // or 'PUT'
                body: JSON.stringify(props.form), // data can be `string` or {object}!
                headers: {
                    "X-CSRF-Token": token,
                    "Content-Type": "application/json"
                }
            })
            .then(res => res.json())
            .catch(error => console.error("Error:", error))
            .then(data => {
                messageSuccess(data);
                clearValues();
                props.clearFormatDuplicateItemValues();
                props.updateItemFormatDuplicationItem(data.register);
            });
        }else{
            fetch(`/formatos/format_duplication_items`, {
                method: 'POST', // or 'PUT'
                body: JSON.stringify(props.form), // data can be `string` or {object}!
                headers: {
                    "X-CSRF-Token": token,
                    "Content-Type": "application/json"
                }
            })
            .then(res => res.json())
            .catch(error => console.error("Error:", error))
            .then(data => {
                messageSuccess(data);
                clearValues();
                props.clearFormatDuplicateItemValues();
                props.updateDataFormatDuplicationItem(props.format_duplication.id, data.register)
            });
        }
    }

    return (
        <React.Fragment>
            <UncontrolledPopover isOpen={props.isOpen} trigger="legacy" placement="botton" target={props.target} onClick={(e) => e.stopPropagation()}>
                <PopoverHeader>
                    <div className='ui-modals-header-title__container'>
                        <span className='ui-titles_modals'>
                            {props.modeEdit ? "Actualizar registro" : "Crear registro"}
                            <a className="close-popover" onClick={(e) => props.clearFormatDuplicateItemValues()}> <i className="fas fa-times"></i></a>
                        </span> 
                        {/*<span className='ui-name-question-modals ui-icon-in-title ml-0'>{}</span> */}
                    </div>
                </PopoverHeader>
                
                <PopoverBody className="popover-column">
                    <div style={{ width: 300, padding: 4 }}>
                        <div style={{ marginBottom: 12 }}>
                            <input type="hidden" name="question_source_id" value={selectedOptionQuestionSource.question_source_id} />
                            <label style={{ fontWeight: 600, fontSize: 12, marginBottom: 4, display: 'block' }}>Pregunta fuente</label>
                            <Select
                                onChange={handleChangeAutocompleteQuestionSource}
                                options={questionsSource}
                                autoFocus={false}
                                className="link-form"
                                value={selectedOptionQuestionSource}
                                placeholder="Seleccione una pregunta..."
                            />
                            <span style={{ fontSize: 10, color: '#999', marginTop: 2, display: 'block' }}>Campo del subformulario fuente a copiar</span>
                        </div>

                        <div style={{ marginBottom: 12 }}>
                            <input type="hidden" name="question_target_id" value={selectedOptionQuestionTarget.question_target_id} />
                            <label style={{ fontWeight: 600, fontSize: 12, marginBottom: 4, display: 'block' }}>Pregunta destino</label>
                            <Select
                                onChange={handleChangeAutocompleteQuestionTarget}
                                options={questionsTargetFiltered}
                                autoFocus={false}
                                className="link-form"
                                value={selectedOptionQuestionTarget}
                                isDisabled={!selectedSourceType}
                                placeholder={!selectedSourceType ? "Seleccione primero una pregunta fuente" : `Preguntas tipo ${selectedSourceType}`}
                            />
                            <span style={{ fontSize: 10, color: '#999', marginTop: 2, display: 'block' }}>Solo muestra preguntas del mismo tipo que la fuente</span>
                        </div>

                        <button className='btn btn-info btn-sm btn-block' onClick={() => handleClick()}>
                            {props.modeEdit ? "Actualizar" : "Mapear campo"}
                        </button>
                    </div>
                </PopoverBody>
            </UncontrolledPopover>
        </React.Fragment>
    );
}

export default FormCreate;

